if (!customElements.get('accordions-block')) {
  customElements.define(
    'accordions-block',
    class AccordionsBlock extends HTMLElement {
      constructor() {
        super()
        this.buttons = this.querySelectorAll('[data-tag-selector]')
        this.items = this.querySelectorAll('[data-accordion-line]')
        this.initEvents()
      }

      initEvents() {
        this.buttons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.target.classList.toggle('accordion-tag--active')
            this.updateAccordions()
          })
        })
      }

      updateAccordions() {
        const activeButtons = this.querySelectorAll('.accordion-tag--active')
        if (activeButtons.length > 0) {
          const activeTags = []
          activeButtons.forEach((btn) => {
            activeTags.push(btn.dataset.tagSelector)
          })
          this.items.forEach((item) => {
            let includeTag = false
            activeTags.forEach((tag) => {
              if (item.dataset.tags && item.dataset.tags.includes(tag)) includeTag = true
            })
            if (includeTag) item.classList.remove('hidden')
            else item.classList.add('hidden')
          })
        } else {
          this.items.forEach((item) => item.classList.remove('hidden'))
        }
      }
    },
  )
}
